import React from 'react';
import Blanket from '@atlaskit/blanket';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { DrawerContentProps } from '../types.tsx';

export const preloadAsyncProjectCreateDrawer = () =>
	import(/* webpackChunkName: "async-project-create-drawer" */ './index');

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyComponent = lazy(
	() =>
		// eslint-disable-next-line jira/import/webpack-magic-comment-entries
		import(/* webpackChunkName: "async-project-create-drawer" */ './index'),
	{
		includeInShellOnlySsrBundle: true,
	},
);

const newComponent = (props: DrawerContentProps) => (
	<JSErrorBoundary
		id="bundle-async-project-create-drawer"
		fallback="flag"
		packageName="jira-project-create-drawer"
		teamName="helix"
	>
		<Placeholder name="async-project-create-drawer" fallback={<Blanket isTinted />}>
			<LazyComponent {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export const AsyncProjectCreateDrawerContent = newComponent;
